import { createApp } from 'vue'
import { createYmaps } from 'vue-yandex-maps';
// import naive from '../node_modules/naive-ui'
// import VueUeditorWrap from 'vue-ueditor-wrap';
import App from './App.vue'
import {createMetaManager} from 'vue-meta'
import router from './router'
import store from './store'


createApp(App)
// .use(naive)
    .use(store)
    .use(router)
    // .use(VueUeditorWrap)
    .use(createMetaManager())
    .use(createYmaps({apikey: 'f4c96130-0d6d-464b-9fb4-8ef31ed38d33',}))
    .mount('#app')

